import React from 'react';
import { EXAM_UNIT_PRICE } from 'exam-pricing';
import { LATE_FEE } from 'late-fee';

// Components
import ApplyExamCard from 'components/profile/apply-exams/ApplyExamCard';

// วันตาม tcas-vault timeline/TCAS70.md ↔ enabled.tgattpat_apply_exams (start / expired / late_payment_expired)
// ช่วงสมัครล่าช้า (ทปอ. 17 ต.ค. 69) = สมัคร/เพิ่มวิชาได้ ค่าสมัครเดิม + 200 บาทต่อการยืนยัน ใช้สิทธิ์ อว. ได้ — src/late-fee.js
// G27-4: TCAS70 ไม่มีการสอบ CBT (ไม่มี window tgattpat.cbt_apply — ยืนยัน OTP ล้มทุกครั้ง) — ถอดกล่องสมัคร CBT
const SectionApplyTGATTPAT = () => (
  <ApplyExamCard
    examKey='tgattpat'
    windowKey='tgattpat_apply_exams'
    title='สมัครสอบ TGAT/TPAT2-5'
    details={[
      'รับสมัคร 4 - 10 พ.ย. 69',
      `สมัครล่าช้า 11 - 12 พ.ย. 69 (ค่าธรรมเนียมสมัครล่าช้า ${LATE_FEE} บาท ต่อการยืนยันการสมัคร)`,
      `ค่าสมัครวิชาละ ${EXAM_UNIT_PRICE.tgattpat} บาท (อว. สนับสนุนวิชาละ ${EXAM_UNIT_PRICE.tgattpat} บาท)`,
    ]}
  />
);

export default SectionApplyTGATTPAT;
